module.exports = __webpack_public_path__ + "static/media/o2.742d60dc.jpeg";